import React from 'react';
import {Breadcrumbs as MuiBreadcrumbs, Link, Typography} from '@mui/material';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import {useFileContext} from '../context/FileContext';

const LINK_STYLES = {
   cursor: 'pointer',
   transition: 'color 0.3s',
   '&:hover': {
      color: 'primary.main',
      textDecoration: 'underline',
   },
};
const Breadcrumbs: React.FC = () => {
   const {currentFolder, loadFolder} = useFileContext();

   const path = currentFolder?.path || '';
   const pathParts = path.split('/').filter(Boolean);

   const handleBreadcrumbClick = async (index: number) => {
      const newPath = '/' + pathParts.slice(0, index + 1).join('/');
      await loadFolder(newPath);
   };

   const handleRootClick = async () => {
      await loadFolder('/');
   };

   return (
      <MuiBreadcrumbs aria-label="breadcrumb">
         <Link color="inherit" onClick={handleRootClick} sx={LINK_STYLES}>
            <HomeOutlinedIcon />
         </Link>
         {pathParts.map((part, index) => {
            const isLast = index === pathParts.length - 1;
            return isLast ? (
               <Typography key={index} color="text.primary">
                  {part}
               </Typography>
            ) : (
               <Link
                  key={index}
                  color="inherit"
                  onClick={() => handleBreadcrumbClick(index)}
                  sx={LINK_STYLES}
               >
                  {part}
               </Link>
            );
         })}
      </MuiBreadcrumbs>
   );
};

export default Breadcrumbs;
